(ns frontend.ui.component.lp-portal.checkbox.view
  (:require
   [herb.core :refer [<class]]
   [frontend.ui.component.lp-portal.checkbox.style :as style]))

(defn checkbox
  [{:keys [value on-change size-px] :as props}]
  (if value
    [:i.fa.fa-check-square
     {:class    (<class style/checkbox-checked)
      :style    (when size-px (style/size size-px))
      :on-click (fn [] (on-change true))}]
    [:div
     {:class    (<class style/checkbox-unchecked)
      :style    (when size-px (style/size size-px))
      :on-click (fn [] (on-change false))}]))
